<div class="row" [loadingOverlay]="isLoading">
  <div class="col-md-12">
    <div class="card card-warning">
      <div class="card-header">
        Instructions
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <h5 class="fw-bold">General Instructions</h5>
            <p>Using only the official verified sources (in order of authority), review and fill out every field in the listing that you possibly can. If you have reviewed all verified sources and cannot find a piece of information, leave it blank. If more than half of this listing is blank, or if additional unique sources are needed, workblock this task to request more information.</p>
            <p>Official Verified Sources (in order of authority):</p>
            <ul>
              <li><a [externalLink]="{ url: customerUrl, text: 'Customer\’s Website' }" rel="noreferrer"></a></li>
              <li><a [externalLink]="{ url: gbpUrl, text: 'Google Business Profile' }" rel="noreferrer"></a></li>
              <li><a [externalLink]="{ url: appleMapsUrl, text: 'Apple Maps' }" rel="noreferrer"></a></li>
              <li><a [externalLink]="{ url: bingUrl, text: 'Bing Local' }" rel="noreferrer"></a></li>
              <li><a [externalLink]="{ url: yelpUrl, text: 'Yelp' }" rel="noreferrer"></a></li>
              <li><a [externalLink]="{ url: facebookUrl, text: 'Facebook' }" rel="noreferrer"></a> (login required)</li>
            </ul>
          </div>
          @if (localProfileRequirements?.HasOpenInitialization) {
            <div class="col-md-6">
              <h5 class="fw-bold">Onboarding Instructions</h5>
              <p><span class="fw-bold">Number of Local Profiles:</span> {{localProfileRequirements.RequiredLocalProfiles}}</p>
              <p><span class="fw-bold">Number of Subscriptions:</span> {{localProfileRequirements.RequiredSubscriptions}}</p>
              <p *ngIf="localProfileRequirements.Note"><span class="fw-bold">Note:</span> {{localProfileRequirements.Note || 'N/A'}}</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div> 
<div class="row">
  <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          Local Profiles
        </div>
        <div class="card-body" style="min-height: 700px">
          <app-components-shared-local-profiles
            [canAddLocalProfile]="true"
            [requireFullLocalProfileOnAdd]="true"
            [requireFullValidation]="true"
            [customer]="customer"
            [showSubscriptions]="false"
            [showResearch]="true"
            [showCampaignKeywords]="true">
          </app-components-shared-local-profiles>
        </div>
      </div>
  </div>
</div>
<app-floating-panels>
  <app-floating-panel [displayConfig]="{ title: 'Comments', icon: 'fa-comments', badgeCount: currentAction().TaskDetails.TaskNotes.length }">
    <app-components-specialist-actioncomponents-comments *floatingPanelContent [comments]="taskDetails.TaskNotes">
    </app-components-specialist-actioncomponents-comments>
  </app-floating-panel>
</app-floating-panels>
